import React, { Component, Fragment } from "react";
import api from "../../services/api";

export const SolicitacaoAdesaoHistory =

class extends Component {
	
	constructor(props){
		super(props);
		this.state = {
			historico: [],
			carregandoHistorico: false,
			pesquisaExecutada: false,
		};
		this.toggleJustificativa = this.toggleJustificativa.bind(this);
	}

	render() {
		const { historico, carregandoHistorico, pesquisaExecutada} = this.state;
		return (
			<div>						
				{(historico.length > 0) &&	
					<table className="history-table">
						<tbody>
							{ historico.map((hist, index) =>
								<Fragment key={index}>
									<tr>
										<td className="text-right action-td">
											<b>{hist.nomeAndamento}</b> por <b>{hist.nomeAutor}</b> em <b>{hist.dataHistorico}</b> 
											
											{hist.exibeExpandirComprimir === true &&
												<button type="button" onClick={() => this.toggleJustificativa(index)} title={hist.mostraJustificativa ? "Comprimir Justificativa" : "Expandir Justificativa"}>
													<span className="sr-only">Expandir/Comprimir Justificativa</span>
													<i className={hist.mostraJustificativa ? "fas fa-minus-square" : "fas fa-plus-square"}></i>
												</button>
											}
										</td>
									</tr>
									{hist.mostraJustificativa &&
										<tr>
											<td>
												<textarea value={hist.justificativa} readOnly={true} style={{height:"120px"}}/>
											</td>
										</tr>
									}
								</Fragment>
							)}
						</tbody>						
					</table>
				}
				{(pesquisaExecutada && (historico.length === 0)) &&
					<div>
						Nenhum andamento encontrado para a solicitação de adesão.
					</div>
				}
				{ carregandoHistorico === true  && 
					<button className="br-button is-secondary is-circle is-loading" type="button"/>
				}
			</div>
		);
	}

	componentDidMount(){
		const solicitacao = this.props.solicitacao;
		if(solicitacao) {
			this.setState({
				carregandoHistorico: true,
			})
			
			api.get(`/api/solicitacao-adesao-arquivo-gv/historico/${solicitacao}`)
			.then(response => { 
					let historico = response.data;
					historico = historico.map((hist) => {
						const justificativa = hist.justificativa;
						hist['exibeExpandirComprimir'] = justificativa !== null && justificativa.length > 0;
						hist['mostraJustificativa'] = false;
						return hist;
					})

					this.setState(
						{
							historico,
							pesquisaExecutada: true,
						}
					) 
				})
				.catch(erro => {
					console.log("Não foi possível recuperar o histórico da solicitação." + erro)
					this.props.exibeMensagemErro("Erro durante o carregamento da página")
				}).finally(() => {
					this.setState({carregandoHistorico: false})
				});
		}
	}

	toggleJustificativa(index) {
		const historico = this.state.historico;
		historico[index]['mostraJustificativa'] = ! historico[index]['mostraJustificativa'];
		this.setState({historico});
	}
	
}
